import { action } from '@play-co/replicant';
import { Conversation } from '.';
import { Dialog } from './conservation.ruleset';
import { defineActions } from '../utils';

export const conversationActions = (
  Conversation: Pick<Conversation, 'modifiers'>,
) =>
  defineActions<Conversation>()({
    incrementDialogTimesSeen: action((state, dialogId: Dialog['id']) => {
      Conversation.modifiers(state).incrementTimesSeen(dialogId);
    }),

    saveConversationAnswer: action(
      (state, answer: { answerVar: string; key?: string; value: string }) => {
        Conversation.modifiers(state).saveAnswer(answer);
      },
    ),
  });
